import { Theme } from '@mui/material'

const useStyles = {
  container: (theme: Theme) => ({
    color: 'white',
    margin: theme.spacing(0, -1, 0, -1),
    [theme.breakpoints.up('sm')]: {
      width: '350px',
      margin: '0 auto',
    },
  }),
  headerContent: (theme: Theme) => ({
    marginBottom: theme.spacing(4),
    paddingX: theme.spacing(1),
  }),
  headerContentShort: (theme: Theme) => ({
    marginBottom: theme.spacing(0.5),
  }),
  tipsSubheaders: {
    fontWeight: 500,
    lineHeight: '28px',
  },
  worksWellWrapper: (theme: Theme) => ({
    backgroundColor: theme.palette.success.light,
    color: theme.palette.text.primary,
    padding: theme.spacing(2, 0, 3, 2),
    position: 'relative',
    left: '50%',
    right: '50%',
    marginLeft: '-50vw',
    marginRight: '-50vw',
    width: '100vw',
    [theme.breakpoints.up('sm')]: {
      position: 'static',
      left: 'auto',
      right: 'auto',
      marginLeft: 0,
      marginRight: 0,
      width: 'auto',
    },
  }),
  notHereWrapper: (theme: Theme) => ({
    backgroundColor: theme.palette.error.light,
    color: theme.palette.text.primary,
    marginTop: '-1px',
    padding: theme.spacing(2, 0, 1, 2),
    position: 'relative',
    left: '50%',
    right: '50%',
    marginLeft: '-50vw',
    marginRight: '-50vw',
    width: '100vw',
    [theme.breakpoints.up('sm')]: {
      position: 'static',
      left: 'auto',
      right: 'auto',
      marginLeft: 0,
      marginRight: 0,
      width: 'auto',
    },
  }),
  divider: (theme: Theme) => ({
    marginLeft: theme.spacing(-2),
    marginBottom: theme.spacing(0.5),
  }),
  centerAlign: () => ({
    display: 'flex',
    justifyContent: 'center',
  }),
  lightbulbIconWrapper: (theme: Theme) => ({
    backgroundColor: theme.palette.primary.light,
    borderRadius: theme.spacing(0.5),
    height: theme.spacing(3),
    width: theme.spacing(3),
  }),
  lightbulbIcon: (theme: Theme) => ({
    color: theme.palette.primary.dark,
    fontSize: '16px',
  }),
  tipsIcon: (theme: Theme) => ({
    color: theme.palette.text.secondary,
  }),
  dialogActions: {
    justifyContent: 'center',
    padding: '20px 8px',
  },
  checkboxFormControlLabel: (theme: Theme) => ({
    marginTop: theme.spacing(3),
  }),
  checkbox: (theme: Theme) => ({
    color: theme.palette.common.white,
    '&.Mui-checked': {
      color: theme.palette.common.white,
    },
    margin: theme.spacing(0, 1),
  }),
  footer: {
    height: 'auto',
  },
  leak5sTipsWrapper: (theme: Theme) => ({
    marginTop: theme.spacing(-2),
    paddingX: theme.spacing(1),
  }),
  leak5sCheckIcon: (theme: Theme) => ({
    color: theme.palette.common.white,
  }),
  leak5sTipText: {
    lineHeight: '24px',
    letterSpacing: '0.15px',
    fontSize: '16px',
    marginRight: '16px',
  },
  leak5sCommercialTipText: (theme: Theme) => ({
    lineHeight: '24px',
    letterSpacing: '0.15px',
    fontSize: '16px',
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
  }),
  tipBodyText: {
    marginRight: '16px',
  },
  outerContainer: (isShortScreen: boolean, isLeakFreeze: boolean) => ({
    flexDirection: 'column',
    paddingTop: isShortScreen || isLeakFreeze ? 2.5 : 8,
  }),
  leakFreezeHintRow: (isShortScreen: boolean) => ({
    gap: '12px',
    marginLeft: '8px',
    marginTop: isShortScreen ? '8px' : '-8px',
    marginBottom: '24px',
  }),
  leakFreezeHintIconWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  leakFreezeTitle: {
    fontWeight: '300',
    textAlign: 'center',
  },
}

export default useStyles
